import styled, { css } from 'styled-components';
import Button from 'components/Button';

export const SkinWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  transition: 135ms ease-in-out;

  ${(props) =>
    props.paused &&
    css`
      opacity: 0;
    `};
`;

export const ClickWrapper = styled.div`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const ResumeWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: initial;
`;

export const RightPart = styled.div`
  position: relative;
  font-size: 0;
`;

export const ResumeIconWrap = styled.div`
  position: absolute;
  height: 32px;
  width: 25px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const TopWrapper = styled.div`
  position: absolute;
  top: 15px;
  left: 20px;
  right: 5px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  pointer-events: none;
`;

export const TopTitleWrap = styled.div`
  position: relative;
`;

export const TopCounterWrap = styled.div`
  padding-top: 5px;
  opacity: 0.5;
`;

export const BottomWrapper = styled.div`
  position: absolute;
  height: 40px;
  bottom: 5px;
  left: 2px;
  right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;

  ${RightPart} {
    font-size: 0;
  }
`;

export const LeftPart = styled.div`
  position: relative;
`;

export const CenterPart = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

export const CloseButton = styled(Button)`
  && {
    position: absolute;
    top: 2px;
    right: 7px;
    padding: 8px;
    pointer-events: all !important;
    flex-shrink: 0;
  }
`;

export const TitleWrap = styled.div`
  position: absolute;
  top: -25px;
  left: 50%;
  text-align: center;
  transform: translate(-50%, 0);
  white-space: nowrap;
  color: white;

  ${({ justLink }) =>
    justLink &&
    css`
      position: static;
      transform: translate(0, 0);
    `};
`;

export const TextWrap = styled.div`
  width: 100%;
`;

export const TopLeftPart = styled(LeftPart)`
  position: relative;
  width: calc(100% - 40px);
`;

export const AdSkinStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100px;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    z-index: -1;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0)
    );
    z-index: -1;
  }

  ${(props) =>
    props.disableClicks &&
    css`
      pointer-events: none;
    `};

  ${(props) =>
    props.isMobile &&
    css`
      ${TopWrapper} {
        top: 10px;
        left: 10px;
        right: 10px;
      }

      ${CenterPart} {
        width: 75%;
      }

      ${LeftPart} {
        width: 100%;
        text-align: center;
      }

      ${TopTitleWrap} {
        padding-top: 5px;
        width: 80%;
        margin: 0 auto;
      }

      ${TitleWrap} {
        top: -20px;
      }

      ${TopCounterWrap} {
        padding-top: 0;
      }

      ${BottomWrapper} {
        height: 60px;
        padding: 0 20px 0 8px;
        left: 0;
        right: 0;
        bottom: 0;
      }
      ${CloseButton} {
        width: 45px;
        height: 45px;
        right: 4px;
        top: 0;
      }
    `};
`;

export const PointerEventsAll = styled.div`
  pointer-events: all;
`;
